import { mount } from "@vue/test-utils";
import PhoneNumber from "@/components/core/composite/combos/PhoneNumber";

jest.mock("@/components/core/composite/combos/PhoneNumber", () => ({
  default: {}
}));

describe("PhoneNumber test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(PhoneNumber);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component PhoneNumber", () => {
    expect(wrapper).toBeDefined();
  });
});
